
function adjustFemaleWatchHeights() {
  
    document.querySelectorAll(".product-wrapper-new-div").forEach(wrapper => {    
      const filters = wrapper.getAttribute("data-filters")?.toLowerCase() || "";

      if (filters.includes("ladies") || filters.includes("ladies'") || filters.includes("women")) {
        const img = wrapper.querySelector(".product-wrapper-images-new");
        const productDiv = wrapper.querySelector(".product-new");

        if (window.innerWidth == 320) {
          if (img) img.style.height = "180px";
          if (productDiv) productDiv.style.height = "270px";
        }
        else if (window.innerWidth <= 480) {
          if (img) img.style.height = "190px";
          if (productDiv) productDiv.style.height = "270px";
        } 
        else if (window.innerWidth <= 580) {
          if (img) img.style.height = "200px";
          if (productDiv) productDiv.style.height = "270px";
        } 
        else if (window.innerWidth <= 768) {
          if (img) img.style.height = "235px";
          if (productDiv) productDiv.style.height = "300px";
        } 
        else if (window.innerWidth <= 940) {
          if (img) img.style.height = "200px";
          if (productDiv) productDiv.style.height = "270px";
        } 
        else if (window.innerWidth <= 1044) {
          if (img) img.style.height = "235px";
          if (productDiv) productDiv.style.height = "320px";
        } 
        else if (window.innerWidth <= 1140) {
          if (img) img.style.height = "230px";
          if (productDiv) productDiv.style.height = "350px";
        } 
        else if (window.innerWidth >= 1600) {
          if (img) img.style.height = "300px";
          if (productDiv) productDiv.style.height = "460px";
        } 
        else if (window.innerWidth >= 2200) {
          if (img) img.style.height = "320px";
          // if (productDiv) productDiv.style.height = "460px";
        } 
        else {
          if (img) img.style.height = "265px";
          if (productDiv) productDiv.style.height = "370px";
        }

        // Always center content
        if (productDiv) {
          productDiv.style.justifyContent = "center";
          productDiv.style.display = "flex";
        }
      }
  });
}

// Run once on page load
document.addEventListener("DOMContentLoaded", adjustFemaleWatchHeights);

// Run again whenever screen is resized
window.addEventListener("resize", adjustFemaleWatchHeights);


$("body").on("click", ".productinfo_add_to_cart_index_new", function (e) {
  e.preventDefault();

  var _vid = $(this).attr("data-id");
  var _items = [{ quantity: 1, id: _vid }];
  var button = $(this);
  var loader_new = $(this)
    .closest(".product-details-new")
    .find(".loaderrr-new");

  // console.log('_vid', _vid);
  // console.log('_items', _items);

  button.css("opacity", "0.5");
  // button.hide();
  // loader_new.show();

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: JSON.stringify({ items: _items }),
    contentType: "application/json",
    dataType: "json",

    success: function (msg) {
      button.show();
      loader_new.hide();

      var productButton = $(
        '.standard_button_index[data-id="' + _items[0].id + '"]'
      );

      productButton.css({
        opacity: "1",
        "background-image":
          'url("https://cdn.shopify.com/s/files/1/0878/7660/0115/files/shopping-cart.png?v=1738079598")',
        width: "32px",
        height: "32px",
      });

      var _count =
        $("#items_in_cart_count").html() != ""
          ? parseInt($("#items_in_cart_count").html()) + 1
          : 1;
      if (_count > 0) {
        $(".icon-bag").addClass("active");
      }
      $("#items_in_cart_count, .cart_bubble").html(_count);
      $(".cart_bubble").addClass("active");
    },

    error: function (xhr, status, error) {
      console.error("Error adding to cart:", error);
      button.show();
      loader_new.hide();
    },
  });
});
